<template>
  <div class="home">
    <cookie-law
      buttonText="Ok!"
      message="Este site utiliza cookies de terceiros para recompilar informação estatística sobre sua navegação. Se continuar a navegar, consideramos que aceita o uso."
    ></cookie-law>
    <Initial></Initial>
    <span v-if="!start">
      <Nucleo01></Nucleo01>
      <Nucleo03></Nucleo03>
      <Nucleo04></Nucleo04>
      <Nucleo02></Nucleo02>
      <Nucleo05></Nucleo05>
      <Nucleo06Domino></Nucleo06Domino>
      <Nucleo07></Nucleo07>
      <Nucleo08></Nucleo08>
      <Nucleo08Estatistica></Nucleo08Estatistica>
      <Nucleo09></Nucleo09>
      <Nucleo08Texto></Nucleo08Texto>
      <Nucleo10></Nucleo10>
      <Nucleo11LinhaTempo></Nucleo11LinhaTempo>
      <Nucleo12></Nucleo12>
      <Nucleo13></Nucleo13>
      <Nucleo14></Nucleo14>
    </span>
    <audio :autoplay="false" id="audiooo00" class="audio-none">
      <source src="@/assets/audios/fundo.mp3" type="audio/mpeg" />
    </audio>
    <audio v-if="sound" autoplay loop @play="play" id="audiooo">
      <source src="@/assets/audios/fundo.mp3" type="audio/mpeg" />
    </audio>
  </div>
</template>

<script>
import CookieLaw from "vue-cookie-law";
import Initial from "@/components/sections/Initial.vue";
import Nucleo01 from "@/components/sections/Nucleo01.vue";
import Nucleo02 from "@/components/sections/Nucleo02.vue";
import Nucleo03 from "@/components/sections/Nucleo03.vue";
import Nucleo04 from "@/components/sections/Nucleo04.vue";
import Nucleo05 from "@/components/sections/Nucleo05.vue";
import Nucleo06Domino from "@/components/sections/Nucleo06Domino.vue";
import Nucleo07 from "@/components/sections/Nucleo07.vue";
import Nucleo08 from "@/components/sections/Nucleo08.vue";
import Nucleo08Estatistica from "@/components/sections/Nucleo08Estatistica.vue";
import Nucleo08Texto from "@/components/sections/Nucleo08Texto.vue";
import Nucleo09 from "@/components/sections/Nucleo09.vue";
import Nucleo10 from "@/components/sections/Nucleo10.vue";
import Nucleo11LinhaTempo from "@/components/sections/Nucleo11LinhaTempo.vue";
import Nucleo12 from "@/components/sections/Nucleo12.vue";
import Nucleo13 from "@/components/sections/Nucleo13.vue";
import Nucleo14 from "@/components/sections/Nucleo14.vue";

export default {
  name: "Home",
  computed: {
    sound() {
      return this.$store.state.soundFundo;
    },
    start() {
      return this.$store.state.start;
    },
  },
  methods: {
    play() {
      const audio = document.getElementById("audiooo");
      if (audio) {
        console.log(audio);
        audio.volume = 0.4;
      }
    },
  },
  components: {
    CookieLaw,
    Initial,
    Nucleo01,
    Nucleo02,
    Nucleo03,
    Nucleo04,
    Nucleo05,
    Nucleo06Domino,
    Nucleo07,
    Nucleo08,
    Nucleo08Estatistica,
    Nucleo08Texto,
    Nucleo09,
    Nucleo10,
    Nucleo11LinhaTempo,
    Nucleo12,
    Nucleo13,
    Nucleo14,
  },
};
</script>
<style lang="scss" scoped>
.home {
  min-height: 100vh;
  background: linear-gradient(
    180deg,
    #ffffff 1.04%,
    #ffdbc0 31.25%,
    #c4e7ff 76.04%,
    #fddde8 90.62%,
    #e8f7be 100%
  );
}

.audio-none {
  opacity: 0;
}
</style>
